import { isoLocalDateTime } from '@/tools/format';

export function getEmptyOrder () {
  return {
    orderId: null
  };
}

export function getDataForBeginPurchase (context, payByClubCard = false, payBySpb = false) {
  const order = (position, productId, quantity, price) => ({ position, productId, quantity, price });
  const orderFiltered = [];
  let iterator = 0;
  let orderSum = 0;
  context.state.shoppingCart.forEach((element) => {
    if (element.qnt > 0) {
      orderSum += element.qnt * element.price;
      orderFiltered.push(order(iterator, element.productId, element.qnt, element.price));
      iterator++;
    }
  });
  const result = {
    data: {
      order: [...orderFiltered],
      phone: context.state.phone,
      email: context.state.email,
      cardNum: context.state.configuration.cardNum,
      visitDate: context.state.configuration.useVisitDate ? isoLocalDateTime(context.state.visitDate).slice(0, -1) : null,
      toMainUrl: context.state.configuration.backUrl || context.state.configuration.mainUrl,
      posId: context.state.configuration.posId,
      payByClubCard: payByClubCard,
      payBySpb: payBySpb
    },
    orderSum
  };
  return result;
}
